import React from 'react';

const inputName = (group, name) => {
  if (group === null || group === '') {
    return name;
  }

  return `${group}[${name}]`;
};

const RadioInput = (props) => {
  const {
    inputId,
    groupName,
    name,
    value,
    onChange,
    checked,
    inputClassName,
    disabled,
  } = props;

  return (
    <input
      type="radio"
      id={inputId}
      name={inputName(groupName, name)}
      value={value}
      onChange={onChange}
      checked={checked}
      className={inputClassName}
      disabled={disabled} />
  );
};

RadioInput.defaultProps = {
  groupName: 'parameters',
  name: '',
  checked: false,
};

export default RadioInput;
